import React from 'react';

import { OverflowSpan } from '@/shared/components/ui/overflow-text/overflow-text.styled';
import { TOverflowTextProps } from '@/shared/components/ui/overflow-text/overflow-text.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { useTextOverflow } from '@/shared/hooks/use-text-overflow/use-text-overflow';

export const OverflowText: React.FC<TOverflowTextProps> = ({
  text,
  children,
  tooltipPlacement = 'bottom-start',
}) => {
  const { ref, isOverflowing } = useTextOverflow<HTMLSpanElement>(text);

  return (
    <Tooltip
      title={isOverflowing ? text : ''}
      arrow
      noMaxWidth
      placement={tooltipPlacement}
      textAlign="left"
    >
      <OverflowSpan ref={ref}>{children ?? text}</OverflowSpan>
    </Tooltip>
  );
};
